import { chatManageApi, newestPinFirst } from '@/store/api/conversation/chat/chat.manage.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeChatMessage } from '@/types/conversation/types.conversation.chat.message';
import { dropById } from '@/store/api/base/api.cache';

export const syncChatPinned = (dispatch: TypeAppDispatch, message: TypeChatMessage): void => {
    dispatch(chatManageApi.util.updateQueryData('listChatPinned', message.channelId, (draft) => {
        const index = draft.findIndex((item) => item.id === message.id);
        if (!message.pinnedAt) {
            if (index >= 0) draft.splice(index, 1);
            return;
        }
        if (index >= 0) draft[index] = message;
        else draft.push(message);
        draft.sort(newestPinFirst);
    }));
};

export const dropChatPinned = (dispatch: TypeAppDispatch, ref: { id: string; channelId: string }): void => {
    dispatch(chatManageApi.util.updateQueryData('listChatPinned', ref.channelId, (draft) => {
        dropById(draft, ref.id);
    }));
};
